import { render } from "./SupplierInfosModal.vue?vue&type=template&id=366f5d5c&ts=true&lang=pug"
import script from "./SupplierInfosModal.vue?vue&type=script&lang=ts"
export * from "./SupplierInfosModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__